import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SelectItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { DriverAttributeType } from '../../../driver/models/credential/driver-attribute-type.model';
import { DriverAttribute } from '../../../driver/models/credential/driver-attribute.model';
import { DriverAttributeAccessType } from '../../../driver/models/enums/driver-attribute-access-type.enum';
import { DriverAttributeCategoryType } from '../../../driver/models/enums/driver-attribute-category-type.enum';
import { DriverCredentialApplicationItemSourceType } from '../../../driver/models/enums/driver-credential-application-item-source-type.enum';
import { AttributeTypeService } from '../../../driver/services/attribute-type.service';
import { DriverRestrictionService } from '../../../driver/services/driver-restriction.service';
import { BaseComponent } from '../../../shared/base-components/base.component';

export class CustomerMrpRestrictionModalComponentContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    selector: 'customer-mrp-restriction-modal',
    templateUrl: './customer-mrp-restriction-modal.html'
})
export class CustomerMrpRestrictionModalComponent extends BaseComponent {
    public form: UntypedFormGroup;
    public loading = true;
    public saving = false;
    private personRestrictions: DriverAttributeType[] = [];
    public personRestrictionItems: SelectItem[] = [];
    private driverAttributeCategoryTypeEnum = new DriverAttributeCategoryType();
    private itemSourceTypeEnum = new DriverCredentialApplicationItemSourceType();
    private driverAttributeAccessType = new DriverAttributeAccessType();

    constructor(
        public dialogRef: MatDialogRef<CustomerMrpRestrictionModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CustomerMrpRestrictionModalComponentContext,
        private formBuilder: UntypedFormBuilder,
        private attributeTypeService: AttributeTypeService,
        private driverRestrictionService: DriverRestrictionService
    ) {
        super();
        this.form = this.formBuilder.group({
            availableRestrictions: [[], Validators.required],
            restrictionDescription: ['', Validators.compose([Validators.required, Validators.maxLength(255)])]
        });
        this.form.get('restrictionDescription').disable();
        this.form.get('availableRestrictions').valueChanges.subscribe(v => {
            let selectedRestrictions = v;
            let disabled = true;

            if (null != selectedRestrictions) {
                selectedRestrictions.forEach(r => {
                    var restriction = this.personRestrictions.find(x => x.id == r);

                    if (restriction.isAllowDescription && disabled) {
                        disabled = false;
                    }
                });
            }

            if (disabled) {
                this.form.get('restrictionDescription').setValue('');
                this.form.get('restrictionDescription').disable();
            } else {
                this.form.get('restrictionDescription').enable();
            }
        });
    }

    public async ngOnInit() {
        this.attributeTypeService.getAttributeTypes().pipe(
            finalize(() => this.loading = false))
            .subscribe(r => this.setAvailableRestrictions(r.result));
    }

    private setAvailableRestrictions = (restrictions: DriverAttributeType[]): void => {
        this.personRestrictions = restrictions.filter(e => (true == e.active) &&
                                                           (e.driverAttributeAccessTypeId == this.driverAttributeAccessType.Write.id));
        this.personRestrictionItems = this.personRestrictions.map(e => <SelectItem> { label: e.driverAttributeTypeDisplayValue, value: e.id });
    };

    public cancel = (): void => {
        this.dialogRef.close();
    };

    public save = (): void => {
        if (this.form.valid) {
            let restrictions = [];

            let restrictionDescription = this.form.get('restrictionDescription').value;
            let selectedRestrictions = this.form.get('availableRestrictions').value;

            if (null != selectedRestrictions) {
                selectedRestrictions.forEach((selectedRestriction) => {
                    let newRestriction = new DriverAttribute();
                    newRestriction.driverAttributeTypeId = selectedRestriction;
                    newRestriction.customerNumberId = this.data.customerNumberId;
                    newRestriction.driverCredentialApplicationItemSourceTypeId = this.itemSourceTypeEnum.MedicalReview.id;

                    if ((null != restrictionDescription) && (restrictionDescription.length > 0)) {
                        newRestriction.description = restrictionDescription;
                    }
                    restrictions.push(newRestriction);
                });
            }

            this.saving = true;
            this.driverRestrictionService.saveCustomerAttributes(restrictions).pipe(
                finalize(() => this.saving = false))
                .subscribe(r => this.dialogRef.close(true));
        }
    };
}
